import { render, staticRenderFns } from "./Mysql.vue?vue&type=template&id=a81b6830"
import script from "./Mysql.vue?vue&type=script&lang=js"
export * from "./Mysql.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports